<script>
import Login from './HeaderBottomMobileLogin';
import Hamburger from './HeaderBottomMobileHamburger';

export default {
  components: {
    Login,
    Hamburger,
  },
  props: {
    userLoggedIn: Boolean,
    cartQty: Number,
    isWhitelabel: Boolean,
    cart: Object,
  },
};
</script>

<template lang='pug'>
.container.flex.items-center.justify-between.mx-auto.h-full.px-1_5
  
  hamburger(@open-menu='$emit("open-menu")')

  //- logo slot
  slot

  login(
    :user-logged-in='userLoggedIn',
    :cart-qty='cartQty',
    :is-whitelabel='isWhitelabel',
    :cart='cart',
    @log-out='$emit("log-out")',
  )
</template>

<style>
@import '~import/index';

</style>